import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles.scss';
import { FormattedDate as RSFormattedDate } from '../../../public/components/View';


const propTypes = {
    /**
     * Timestamp
     */
    date: PropTypes.number,
    /**
     * Options
     */
    mode: PropTypes.string,
};

const defaultProps = {
    date: undefined,
    mode: 'yyyy-MM-dd',
};

/**
 * Show Timestamp in humanreadable format
 */
@CSSModules(styles, { allowMultiple: true })
export default class FormattedDate extends React.PureComponent {
    static defaultProps = defaultProps;
    static propTypes = propTypes;

    render() {
        return (
            <RSFormattedDate
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/FormattedDate/FormattedDate.js